import './component.scss'
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('search', class extends Controller {
  static targets = [ 'button', 'cards' ]

  initialize() {
    this.hideButtonsExceptFirst()
    this.hideClientCards()
  }

  hideButtonsExceptFirst() {
    const allCtaButton = this.buttonTargets
    allCtaButton.shift()

    allCtaButton.forEach((button) => {
      button.classList.add('invisible')
    })
  }

  hideClientCards() {
    const allCardsContents = this.cardsTargets

    allCardsContents.forEach((contents) => {
      contents.classList.add('invisible')
    })
  }
})

app.register('client-list-accordion', class extends Controller {
  initialize() {
    this.button_idx = 1
  }

  showClientList(e) {
    this.hideButton(e)
    this.showClientCards(e)
    this.showNextButton()
  }

  hideButton(e) {
    e.target.classList.add('invisible')
  }

  showClientCards(e) {
    const nextClientCardsList = e.target.parentNode.getElementsByClassName('splitted-company-card-list')[0]
    nextClientCardsList.classList.remove('invisible')
  }

  showNextButton() {
    this.button_idx++
    const nextButton = document.getElementById(`button_id_${this.button_idx}`)

    if (nextButton === null) {
      return
    }

    nextButton.classList.remove('invisible')
  }
})
